import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DelegationBean } from '../model/DelegationBean';
import { HistoryBean } from '../model/HistoryBean';
import { DatePipe } from '@angular/common';
import { DelegationService } from '../services/delegation-service';
import { EditDelegFormComponent } from '../edit-deleg-form/edit-deleg-form.component';

@Component({
  selector: 'app-edit-delegation',
  templateUrl: './edit-delegation.component.html',
  styleUrls: ['./edit-delegation.component.css']
})
export class EditDelegationComponent {
  @ViewChild('editDelFormComponent') editDelFormComponent: EditDelegFormComponent;
  @Output() cancelEvent = new EventEmitter<boolean>();
  cancel(){
    this.cancelEvent.emit(true);

    }
  constructor(private delegationService: DelegationService, private datePipe: DatePipe){}
  @Input() delegation: DelegationBean;
  history: HistoryBean[];
  @Input() canEdit: boolean;
  onTabChange(event: MatTabChangeEvent) {

  if(event.index ===1){
    this.delegationService.getHistory(this.delegation.routingInfRef?.uuid, this.delegation.user?.cvr).then((data)=>{
      if(data)
      
      data.forEach((i,v) =>{
        i.changeTime = this.datePipe.transform(i.changeTime, 'yyyy-MM-dd HH:mm:ss') || '';
        i.id = v+"";
      })
      this.history =data;
    })

  }
  }
}
